import React, { useState, createContext, useContext, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import DashboardClientComponent from "./pages/Dashboard";
import SideNavBarClientComponent from "./components/SideNavbar";
import TopNavbar from "./components/TopNavbar";
import CategoryManagement from "./pages/Category";
import CreateProduct from "./pages/CreateProduct";
import UserProfile from "./pages/UserProfile";
import UserManagement from "./pages/Users";
import PurchaseManagement from "./pages/Purchases";
import ProductColorManagement from "./pages/ProductColor";
import ProductUnitManagement from "./pages/ProductUnit";
import ProductList from "./pages/ProductList";
import AddPurchase from "./pages/AddPurchase";
import AddSale from "./pages/AddSale";
import SalesManagement from "./pages/Sales";
import AddUser from "./pages/AddUser";
import SalesReport from './pages/SalesReport'
import InventoryReport from './pages/InventoryReport'
import PurchasesReport from './pages/PurchasesReport';
import Inventory from "./pages/Inventory";
const SidebarContext = createContext({ isCollapsed: false, setIsCollapsed: () => {} });
export const useSidebar = () => useContext(SidebarContext);

function ProtectedRoute({ element }) {
  const token = localStorage.getItem("accessToken");
  return token ? element : <Navigate to="/login" replace />;
}

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isCollapsed, setIsCollapsed } = useSidebar();
  const showNav =
    location.pathname !== "/login" &&
    location.pathname !== "/signup" &&
    location.pathname !== "/verify-otp" 
    const [isRedirecting, setIsRedirecting] = useState(false);

    useEffect(() => {
      if (location.pathname === "/") {
        setIsRedirecting(true);
        setTimeout(() => {
          navigate("/login", { replace: true });
          setIsRedirecting(false);
        }, 10); // Tiny delay to prevent UI flash
      }
    }, [location.pathname, navigate]);
  
    if (isRedirecting) {
      return <div className="w-screen h-screen bg-white"></div>; // White screen while redirecting
    }
  
  return (
    <div className={`overflow-y-hidden relative min-h-screen bg-gray-50`}>
      {showNav && (
        <>
          <SideNavBarClientComponent isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
          <TopNavbar />
        </>
      )}
      <div className={`${showNav ? 'ml-64' : 'h-screen overflow-hidden'} p-6 bg-gray-50 transition-all duration-300 ease-in-out`}>
        <Routes>
     
          <Route path="/login" element={<Login />} />
       
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/dashboard" element={<ProtectedRoute element={<DashboardClientComponent />} />} />
          <Route path="/product-category" element={<ProtectedRoute element={<CategoryManagement />} />} />
          <Route path="/add-product" element={<ProtectedRoute element={<CreateProduct />} />} />
          <Route path="/user-profile" element={<ProtectedRoute element={<UserProfile />} />} />
          <Route path="/add-user" element={<ProtectedRoute element={<AddUser />} />} />
          <Route path="/all-users" element={<ProtectedRoute element={<UserManagement />} />} />
          <Route path="/all-purchases" element={<ProtectedRoute element={<PurchaseManagement />} />} />
          <Route path="/product-color" element={<ProtectedRoute element={<ProductColorManagement />} />} />
          <Route path="/product-units" element={<ProtectedRoute element={<ProductUnitManagement />} />} />
          <Route path="/all-products" element={<ProtectedRoute element={<ProductList />} />} />
          <Route path="/add-purchase" element={<ProtectedRoute element={<AddPurchase />} />} />
          <Route path="/add-sale" element={<ProtectedRoute element={<AddSale />} />} />
          <Route path="/all-sales" element={<ProtectedRoute element={<SalesManagement />} />} />
          <Route path="/sales-report" element={<ProtectedRoute element={<SalesReport />} />} />
          <Route path="/inventory-report" element={<ProtectedRoute element={<InventoryReport />} />} />
          <Route path="/purchase-report" element={<ProtectedRoute element={<PurchasesReport />} />} />
          <Route path="/inventory" element={<ProtectedRoute element={<Inventory />} />} />
        </Routes>
        
      </div>
    </div>
  );
}

function App() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <SidebarContext.Provider value={{ isCollapsed, setIsCollapsed }}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </SidebarContext.Provider>
  );
}

export default App;
